import { z } from "zod/v4";
import { taskSchema } from "../schemas/task";
import { fetchApi, fetchVoid } from "./internal";

export const tasks = {
	list: (clubId: string, params?: { status?: string; assignee_id?: string }) => {
		const searchParams = new URLSearchParams();
		if (params?.status) searchParams.set("status", params.status);
		if (params?.assignee_id) searchParams.set("assignee_id", params.assignee_id);
		const qs = searchParams.toString();
		return fetchApi(`/clubs/${clubId}/tasks${qs ? `?${qs}` : ""}`, z.array(taskSchema));
	},
	get: (clubId: string, taskId: string) => fetchApi(`/clubs/${clubId}/tasks/${taskId}`, taskSchema),
	create: (clubId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/tasks`, taskSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, taskId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/tasks/${taskId}`, taskSchema, {
			method: "PATCH",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, taskId: string) =>
		fetchVoid(`/clubs/${clubId}/tasks/${taskId}`, { method: "DELETE" }),
};
